import { Component } from '@angular/core';

@Component({
  selector: 'app-security-question-answer-not-match',
  templateUrl: './security-question-answer-not-match.component.html',
})
export class SecurityQuestionAnswerNotMatchComponent {
  constructor() {}
}
